import CommonState from './CommonState'

/**
 * 触发器定义
 */
export const TRIGGER_INPUT_JOB_NO = new CommonState('_input_job_no_', '输入工作号', 'Input Job Number')
export const TRIGGER_INPUT_WAREHOUSE_INFO = new CommonState('_input_warehouse_info_', '输入进仓信息', 'Input Warehouse Info')
export const TRIGGER_INPUT_SO_NO = new CommonState('_input_so_no_', '输入关单号', 'Input So No')
export const TRIGGER_INPUT_MBL_NO = new CommonState('_input_mbl_no_', '输入MB/L', 'Input MB/L')
export const TRIGGER_INPUT_HBL_NO = new CommonState('_input_hbl_no_', '输入HB/L', 'Input HB/L')
export const TRIGGER_INPUT_TRUCKING_INFO = new CommonState('_input_trucking_info_', '新建派车单', 'Create Trucking')
export const TRIGGER_INPUT_CUSTOMS_INFO = new CommonState('_input_customs_info_', '新建报关单', 'Create Customs Info')

export const TRIGGER_INPUT_MBL_SIGN_DATE = new CommonState('_input_mbl_sign_date_', '输入MBL签发日期', '输入MBL签发日期')
export const TRIGGER_INPUT_HBL_SIGN_DATE = new CommonState('_input_hbl_sign_date_', '输入HBL签发日期', '输入HBL签发日期')

export const TRIGGER_INPUT_BILLING_NO = new CommonState('_input_billing_no_', '输入国内账单号', '输入国内账单号')
export const TRIGGER_INPUT_OVERSEA_BILLING_NO = new CommonState('_input_oversea_billing_no_', '输入国外账单号', '输入国外账单号')

export const TRIGGER_INPUT_ACTUAL_QWC = new CommonState('_input_actual_qwc_', '输入实际件毛体', 'Input Actual Weight')
export const TRIGGER_PRINT_PROFIT = new CommonState('_print_profit_', '输出利润分析表', 'Print Profit')
export const TRIGGER_PRINT_HBL = new CommonState('_print_hbl_', '输出HB/L', 'HBL Printed')
export const TRIGGER_PRINT_MBL = new CommonState('_print_mbl_', '输出MB/L', 'MBL Printed')

//		export const TRIGGER_INPUT_CHARGE = new CommonState('_input_charge_', '输入费用', 'Input Charges')
//		export const TRIGGER_SAVE_BOOKING_INFO = new CommonState('_save_booking_info_', '订舱信息 - 保存', 'Save booking info')
//		export const TRIGGER_SAVE_HBL = new CommonState('_save_hbl_', 'HB/L - 保存', 'Save HBL')
//		export const TRIGGER_SAVE_MBL = new CommonState('_save_mbl_', 'MB/L - 保存', 'Save MBL')
//		export const TRIGGER_SAVE_CONTAINER = new CommonState('_save_container_', '海运装箱 - 保存', 'Save Containers')
//		export const TRIGGER_SAVE_TRUCKING = new CommonState('_save_trucking_', '拖车委托 - 保存', 'Save Containers')
//		export const TRIGGER_MAKE_RECEIVABLE = new CommonState('_make_receivable_', '制作应收', 'Make receiviable')
//		export const TRIGGER_MAKE_PAYABLE = new CommonState('_make_payable_', '制作应付', 'Make payable')
//		export const TRIGGER_PRINTED_HBL = new CommonState('_printed_hbl_', 'HB/L已输出', 'HBL Printed')
//		export const TRIGGER_PRINTED_MBL = new CommonState('_printed_mbl_', 'MB/L', 'MBL Printed')
//		export const TRIGGER_PRINTED_BILL = new CommonState('_printed_bill_', '帐单已输出', 'Bill Printed')
//		export const TRIGGER_VERIFIED_RECEIVABLE_PAYABLE = new CommonState('_verified_receivable_payable_', '应收应付审核完成', 'Verified charges')

// 未实现
export const TRIGGER_EX_OUT_PREWIRED = new CommonState('_ex_out_prewired_', '放箱预配', '放箱预配', null, true)
// 未实现
export const TRIGGER_EX_PREWIRED_SHIPPING_BILL = new CommonState('_ex_prewired_shipping_bill_', '预配舱单', '预配舱单', null, true)
export const TRIGGER_EX_CLP = new CommonState('_ex_receive_clp_', '电子装箱单', '电子装箱单', null, true)
// 未实现
export const TRIGGER_EX_VEHICLE_DISPATCH = new CommonState('_ex_vehicle_dispatch_', '是否派车', '是否派车', null, true)
export const TRIGGER_EX_ENTRY_WS = new CommonState('_ex_entry_es_', '是否进仓', '是否进仓', null, true)
export const TRIGGER_EX_ENTRY_WS2 = new CommonState('_ex_entry_es_2', '货物入库', '货物入库', null, true)
export const EX_MBL_EXAMINE = new CommonState('_ex_mbl_examine', '主单放单已审核', '主单放单已审核', null, true)
export const EX_HBL_EXAMINE = new CommonState('_ex_hbl_examine', '分单放单已审核', '分单放单已审核', null, true)
export const EX_SUBMISSION_PRETRIAL = new CommonState('ex_submission_pretrial', '提交预审', '提价预审', null, true)
export const TRIGGER_EX_CUSTOMS_DONE = new CommonState('_ex_customs_done_', '报关完成', '报关完成', null, true)
export const TRIGGER_EX_CUSTOMER_MBL_CHECKED = new CommonState('_ex_cus_mbl_checked_', '客户提单确认', '客户提单确认', null, true)
export const TRIGGER_EX_CONTAINER_TO_PORT = new CommonState('_ex_container_to_port_', '集装箱进港', '集装箱进港', null, true)
export const TRIGGER_EX_ELECTRONIC_RELEASE = new CommonState('_ex_eletronic_please_', '海关电子放行', '海关电子放行', null, true)
// 未实现
export const TRIGGER_EX_SHIPMENT = new CommonState('_ex_shipment_', '装船', '装船', null, true)
// 未实现
export const TRIGGER_EX_SAIL_OUT = new CommonState('_ex_sail_out_', '开航', '开航', null, true)
// 未实现
export const TRIGGER_EX_ARRIVAL_PORT = new CommonState('_ex_arrival_port_', '在途/到港', '在途/到港', null, true)
export const TRIGGER_INPUT_PART_CONTAINER_NO = new CommonState('_input_part_container_no', '录入部分箱号', '录入部分箱号', null, true)
export const TRIGGER_INPUT_ALL_CONTAINER_NO = new CommonState('_input_all_container_no', '录入全部箱号', '录入全部箱号', null, true)

/**
 * 触发器
 */
export const TRIGGERS = new Set([
  TRIGGER_INPUT_JOB_NO,
  TRIGGER_INPUT_WAREHOUSE_INFO,
  TRIGGER_INPUT_SO_NO,
  TRIGGER_INPUT_MBL_NO,
  TRIGGER_INPUT_HBL_NO,
  TRIGGER_INPUT_TRUCKING_INFO,
  TRIGGER_INPUT_CUSTOMS_INFO,
  TRIGGER_INPUT_MBL_SIGN_DATE,
  TRIGGER_INPUT_HBL_SIGN_DATE,
  TRIGGER_INPUT_BILLING_NO,
  TRIGGER_INPUT_OVERSEA_BILLING_NO,
  TRIGGER_INPUT_ACTUAL_QWC,
  TRIGGER_PRINT_HBL,
  TRIGGER_PRINT_MBL,
  TRIGGER_PRINT_PROFIT,

  TRIGGER_EX_OUT_PREWIRED,
  TRIGGER_EX_PREWIRED_SHIPPING_BILL,
  TRIGGER_EX_CLP,
  TRIGGER_EX_VEHICLE_DISPATCH,
  TRIGGER_EX_ENTRY_WS,
  TRIGGER_EX_ENTRY_WS2,
  EX_MBL_EXAMINE,
  EX_HBL_EXAMINE,
  EX_SUBMISSION_PRETRIAL,
  TRIGGER_EX_CUSTOMS_DONE,
  TRIGGER_EX_CUSTOMER_MBL_CHECKED,
  TRIGGER_EX_CONTAINER_TO_PORT,
  TRIGGER_EX_ELECTRONIC_RELEASE,
  TRIGGER_EX_SHIPMENT,
  TRIGGER_EX_SAIL_OUT,
  TRIGGER_EX_ARRIVAL_PORT,
  TRIGGER_INPUT_PART_CONTAINER_NO,
  TRIGGER_INPUT_ALL_CONTAINER_NO
])

/**
 * 外部状态
 */
export const EX_TRIGGERS = new Set([
  TRIGGER_EX_OUT_PREWIRED,
  TRIGGER_EX_PREWIRED_SHIPPING_BILL,
  TRIGGER_EX_CLP,
  TRIGGER_EX_VEHICLE_DISPATCH,
  TRIGGER_EX_ENTRY_WS,
  TRIGGER_EX_ENTRY_WS2,
  EX_SUBMISSION_PRETRIAL,
  TRIGGER_EX_CUSTOMS_DONE,
  TRIGGER_EX_CUSTOMER_MBL_CHECKED,
  TRIGGER_EX_CONTAINER_TO_PORT,
  TRIGGER_EX_ELECTRONIC_RELEASE,
  TRIGGER_EX_SHIPMENT,
  TRIGGER_EX_SAIL_OUT,
  TRIGGER_EX_ARRIVAL_PORT
])

/**
 * 节点类型定义
 */
export const NOTE_TYPE_LOADINGPORT = new CommonState(1, '起运港', 'LodingPort')
export const NOTE_TYPE_TRANSFERPORT = new CommonState(2, '中转港', 'TransferPort')
export const NOTE_TYPE_DESTINATIONPORT = new CommonState(3, '目的港', 'DestinationPort')
export const NOTE_TYPE_WAREHOUSE = new CommonState(4, '仓储', 'Warehousing')
export const NOTE_TYPE_BOOKING = new CommonState(5, '订舱', 'Booking')
export const NOTE_TYPE_E = new CommonState(6, '委托', 'Entrust')
export const NOTE_TYPE_CONTAINER = new CommonState(7, '做箱', 'Container')
export const NOTE_TYPE_DISTRIBUTION = new CommonState(8, '配送', 'Distribution')
export const NOTE_TYPE_SUPPLEMENT = new CommonState(9, '补充', 'Supplement')

/**
 * 节点类型
 */
export const NOTETYPES = new Set([
  NOTE_TYPE_LOADINGPORT,
  NOTE_TYPE_TRANSFERPORT,
  NOTE_TYPE_DESTINATIONPORT,
  NOTE_TYPE_WAREHOUSE,
  NOTE_TYPE_BOOKING,
  NOTE_TYPE_E,
  NOTE_TYPE_CONTAINER,
  NOTE_TYPE_DISTRIBUTION,
  NOTE_TYPE_SUPPLEMENT
])

/**
 * 状态类型定义
 */
export const STATE_TYPE_NOT_START = new CommonState(1, '未开始', 'NotStart')
export const STATE_TYPE_IN = new CommonState(2, '进行中', 'In')
export const STATE_TYPE_COMPLETE = new CommonState(3, '已完成', 'Complete')
export const STATE_TYPE_EXCPTION = new CommonState(4, '异常', 'Exception')

/**
 * 状态类型
 */
export const STATETYPES = new Set([
  STATE_TYPE_NOT_START,
  STATE_TYPE_IN,
  STATE_TYPE_COMPLETE,
  STATE_TYPE_EXCPTION
])

